import {useParams, useRouteMatch} from 'react-router-dom';
import {PlaylistItemForm} from '../../../../../../../components/playlist-form/playlist-item-form';
import {CaregiverMode} from '../../../../../../../enums';

export default function PlaylistItemDetailsSystemAdministratorOfficeScreen() {
  // Get params
  // - id: playlist id
  // - itemId: playlist item id
  let {id, itemId}: {id?: string; itemId?: string} = useParams();
  if (itemId?.toLowerCase() === 'create') {
    itemId = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <PlaylistItemForm
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite={true}
      showExitButton={itemId ? false : true}
      showPageTitle={itemId ? false : true}
      redirectUrl={
        itemId
          ? `${url.replace(`/playlists/${id}/items/${itemId}`, '')}`
          : `${url.replace(`/playlists/${id}/items/create`, '')}`
      }
    />
  );
}
